"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const spacings_1 = __importDefault(require("./spacings"));
const paddings = {
    collapse: {
        desktop: {
            inline: spacings_1.default.s7,
            block: spacings_1.default.s6,
        },
        mobile: {
            inline: spacings_1.default.s6,
            block: spacings_1.default.s6,
        },
    },
    dashboard: {
        desktop: {
            inline: spacings_1.default.s8,
            block: spacings_1.default.s8,
        },
        mobile: {
            inline: spacings_1.default.s6,
            block: spacings_1.default.s7,
        },
    },
    card: {
        desktop: {
            inline: spacings_1.default.s9,
            block: spacings_1.default.s9,
        },
        mobile: {
            inline: spacings_1.default.s6,
            block: spacings_1.default.s6,
        },
    },
    cardList: {
        desktop: {
            inline: spacings_1.default.s7,
            block: spacings_1.default.s6,
            gapColumn: spacings_1.default.s6,
            gapRow: spacings_1.default.s7,
        },
        mobile: {
            inline: spacings_1.default.s6,
            block: spacings_1.default.s6,
            gapColumn: spacings_1.default.s4,
            gapRow: spacings_1.default.s6,
        },
    },
    gap: {
        desktop: spacings_1.default.s9,
        mobile: spacings_1.default.s7,
    },
    gapList: {
        desktop: spacings_1.default.s6,
        mobile: spacings_1.default.s6,
    },
    buttons: {
        desktop: `0 ${spacings_1.default.s7}`,
        mobile: `0 ${spacings_1.default.s6}`,
    },
    lineHeight: {
        paragraph: spacings_1.default.s4,
        textBlock: spacings_1.default.s1,
    },
    dialog: spacings_1.default.s4,
    input: spacings_1.default.s9,
    icon: spacings_1.default.s4,
    cardTitle: `${spacings_1.default.s5} ${spacings_1.default.s8}`,
};
exports.default = paddings;
//# sourceMappingURL=paddings.js.map